import { ReactNode } from "react"
import { NpIcon, NpIconName } from "src/components/np-design/components/NpIcon"
import { routes } from "src/config/routes"
import { A } from "../unstyled/A"

const Perk = ({ children, icon }: { children: ReactNode; icon: NpIconName }) => {
  return (
    <div className="flex items-center gap-2 text-base">
      <NpIcon name={icon} />
      <span>{children}</span>
    </div>
  )
}

export const ShopPerks = () => {
  return (
    <div className="grid grid-cols-1 gap-4 text-lg">
      <Perk icon="autorenew">30 Tage testen</Perk>
      <Perk icon="thumb_up">Von Eltern getestet</Perk>
      <Perk icon="verified">
        <A href={routes.warranty} className="hover:underline">
          3 Jahre Garantie
        </A>
      </Perk>
    </div>
  )
}
